import { BotImageMessage } from '@/types';
import { motion } from 'framer-motion';
import { useChatStore } from '../../store/chatStore';

type MessageImageProps = {
  message: BotImageMessage;
  messageId: string;
};

const MessageImage = ({ message, messageId }: MessageImageProps) => {
  const { setFullScreenImage } = useChatStore();

  const imageKey = `${messageId}-${message.content}`;

  const handleClick = () => {
    setFullScreenImage({ key: imageKey, image: message.content });
  };

  return (
    <motion.img
      layoutId={imageKey}
      onClick={handleClick}
      className="cursor-zoom-in rounded-xl"
      src={message.content}
      alt={'image'}
      transition={{ duration: 0.3 }}
    />
  );
};

export default MessageImage;
